import styled from 'styled-components';

export const EntOwnersSelect = styled.div`
    min-width: 250px;
    background-color: #F5FBFF;
    border-radius: 6px;
    margin-right: 1rem;
    display: flex;
    //position: relative;
`

export const AddOwner = styled.div`
    width: 10px;
    display: flex;
    justify-content: space-between;
    align-items: start;
    //padding: 0.25rem 1rem;
    margin-right: 1rem;
    cursor: pointer;
    position:relative ;

    & span {
        font-size: 0.9rem;
        color: ${({theme}) => theme.colors.primary};
    }
`

export const SearchOwner = styled.div`
   
    display: flex;
    justify-content: space-between;
    align-items: center;
  padding: 2px;
   // margin-right: 1rem;
    cursor: pointer;
    margin:5px ;
    border:1px solid #1ea7e0 ;
    border-radius: 6px;

`

export const SearchInput = styled.input`
    flex: 1;
    border: none;
    outline: none;
    background-color: #F5FBFF;
    font-size: 0.7rem;
    color: #2174B9;

    &:focus {
        border: none;
        outline: none;
    }

    &::placeholder {
        color: ${({theme}) => theme.colors.gray};
        font-style: italic;
    }
`

export const SecondaryBtnOutlineActionModal = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1rem;
  height: 32px;
  padding: 0px 3px;
  border: 2px solid
    ${({ theme, border }) => (border ? border : theme.colors.gray)};
  border-radius: 6px;
  color: ${({ theme, color }) => (color ? color : theme.colors.primary)};
  cursor: pointer;
  font-size: 0.9rem;
  background-color: #ffffff;
  white-space: nowrap;

  & span {
    color: ${({ theme, color }) => (color ? color : theme.colors.primary)};
  }

  &:hover {
    background-color: ${({ theme, hov }) =>
      hov ? hov : theme.colors.btnHover};
  }
`;

export const PrimaryBtnOutlineActionModal = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  padding: 0px 3px;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 6px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-size: 0.9rem;
  background-color: #ffffff;
  white-space: nowrap;

  & span {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.btnHover};
  }
`;
export const SelectContainerLevel = styled.div`
 background: white;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding: 0.15rem;
    z-index: 100;
    border: 1px solid #1ea7e0;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    position: absolute;
    top: 17px;
    left:5px;
    border-radius: 5px;
      @media (max-width: ${({ theme }) => theme.size.laptopL}) {
           //width:225px ;
            top: 20px;
  left:-65px;
  }

`
export const SelectContainer = styled.div`
  
    width: ${({ width }) => width ? width : "250px" };
    background: white;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;

    z-index: 100;
    border: 1px solid #1ea7e0;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    position: absolute;
    top: 17px;
    left:5px;
    border-radius: 5px;
      @media (max-width: ${({ theme }) => theme.size.laptopL}) {
           width:225px ;
            top: 20px;
  left:-65px;
  }
`

export const SelectOwnersList = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    //position: absolute;
    width: 100%;
    z-index: 100;
    padding: 0 0.5rem 0.5rem 0.5rem;
    //background-color: #F5FBFF;
`
export const SelectOwnersListLevel = styled.div`
height: calc(100% - 60px);
    display: flex;
    flex: 1;
    flex-direction: column;
    //position: absolute;
    width: 100%;
    z-index: 100;
    padding: 0 0.5rem 0.5rem 0.5rem;
    //background-color: #F5FBFF;
`


export const SelectOwnersHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    min-height:14px;
    color: ${({theme}) => theme.colors.secondary};
`

export const SelectOwnersItems = styled.ul`

    width: 100%;
    height: ${({ height }) => height ? height : "100px" };
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0;
`

export const SelectOwnersItemsLevel = styled.ul`

    width: 100%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0;
`
export const SelectOwnersItem = styled.li`
    width: 95%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5rem;
    cursor: pointer;
    
    &:hover {
        background-color: ${({theme}) => theme.colors.btnHover};
    }
`

export const ItemLabel = styled.span`
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #505050 !important;
`

export const ItemCode = styled.span`
    color: ${({theme}) => theme.colors.primary};
`

export const ItemLabelLevel = styled.span`
    width: 65%;
    text-align: start;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #505050 !important;
`
export const ItemLabelParentLevel = styled.span`
    color: ${({ theme }) => theme.colors.primary};
    width: 35%;
    text-align: end;
`